import styles from "./ConsultationDetail.module.css";

import { deleteConsultation } from "../../../../Api/Backend/Consultation";
import { useAuth } from "../../../../Context/AuthContext";


function ConsultationDetail({ data, onBackClick }) {
    const auth = useAuth();

    const consult = data.consultation;
    const formattedDate = new Date(consult.dateCreated).toLocaleString("ko-KR", {
        year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit"
    });

    const handleDelete = async (consultationId) => {
        if (!window.confirm("정말 삭제하시겠습니까?")) return;
        await deleteConsultation({
            auth,
            consultationId,
            onSuccess: () => onBackClick(),
            onError: (e) => alert("삭제에 실패했습니다.")
        });
    };

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <div className={styles.headerRow}>
                    <div className={styles.headerTitle}>
                        <button className={styles.backBtn} onClick={onBackClick}>이전</button>
                        <p className={styles.headerName}>{consult.name}</p>
                    </div>
                    <button
                        onClick={() => handleDelete(consult.consultationId)}
                        className={styles.deleteButton}
                    >
                        삭제
                    </button>
                </div>
                <hr className={styles.divider} />
                <div className={styles.fields}>
                    <div className={styles.field}>
                        <label>이메일</label>
                        <span>{consult.email || "-"}</span>
                    </div>
                    <div className={styles.field}>
                        <label>전화번호</label>
                        <span>{consult.phoneNumber || "-"}</span>
                    </div>
                    <div className={styles.field}>
                        <label>출판유형</label>
                        <span>{consult.publicationType || "-"}</span>
                    </div>
                    <div className={styles.field}>
                        <label>접수일시</label>
                        <span>{formattedDate}</span>
                    </div>
                </div>
            </div>

            <div className={styles.card}>
                <p className={styles.cardTitle}>상담내용</p>
                <p className={styles.detailsText}>{consult.details?.trim() || "-(없음)-"}</p>
            </div>

            <div className={styles.card}>
                <p className={styles.cardTitle}>첨부파일</p>
                <div className={styles.fileList}>
                    {data.files?.length > 0 ? data.files.map((f, i) => (
                        <a key={i} href={f.fileLink} target="_blank" rel="noreferrer" className={styles.fileItem}>
                            <span>{f.fileName}</span>
                            <span className={styles.extIcon}>↗</span>
                        </a>
                    )) : <p className={styles.empty}>첨부파일 없음</p>}
                </div>
            </div>
        </div>
    );
}

export default ConsultationDetail;

// {
//     "consultation": {
//         "consultationId": 2,
//         "name": "Test Name",
//         "email": "test@mail.com",
//         "phoneNumber": null,
//         "details": "This is a test",
//         "publicationType": "기획 출판",
//         "dateCreated": "2026-05-20T14:20:34.388056",
//         "dateModified": null
//     },
//     "files": [
//         {
//             "fileName": "test.txt",
//             "fileLink": "https://drive.google.com/file/d/FILE-ID-HERE/view"
//         },
//         {
//             "fileName": "test_2.txt",
//             "fileLink": "https://drive.google.com/file/d/FILE-ID-HERE/view"
//         }
//     ]
// }